<template>
    <v-app style="margin-top:0px;" >
        <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
            <v-container>
                <h1 style="margin-top:20px;">{{ countryName }}</h1>
            </v-container>
        </v-card>
  <div class="container con" >
        <div class="row" style="margin-top:-100px; " >
          <div class="col-lg-9 col-md-9 col-sm-12" >
        <v-card flat style="border: 1px solid #b6b6b6;">
        <v-container>
            <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
              <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
              <img :src="image" style="width: 50%;height:300px;" />
            <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
              <h3 class="country-heading"><strong>Singapore- the city of Millionaires</strong></h3>
              <p>Singapore, the capital of the Republic of Singapore, the city cum state situated at the southern end of the Malay Peninsula stretched within the 137 kilometers north of the Equator. It consists of 60 small islands and shaped like a diamond.</p>
              <p>From the beginning of 1960, Singapore is economically one of the major trading hubs of British Business. Gradually it has grown and diversified in spectacular way. It has improved its status as global commercial hub and has also grown its financial and industrial sectors. Along with the developing nations in Asia, like South Korea and Taiwan, Singapore is not also enlisted itself as the most developed economy in Southeast Asia. . Singapore's economy has always stood out from those of the other Southeast Asian nations since it has never been largely reliant on the manufacturing and export of goods.</p>
              <h4 class="country-heading">Scope of Study in Singapore</h4>
              <p>As Singapore has sound knowledge of business and it’s become a financial trading hub of many global giants, career of jobs and scope of study here are enormous. Singapore is considered as one of the valuable destination in terms of study. Here are the top 10 reasons those can be justified while one wants to study in Singapore.</p>
              <ul>
              <li>Highly Esteemed Educational System</li>
              <li>Affordable fees compare to other country’s universities (UK,Canada,Australia)</li>
              <li>English is the native language. So no language problem will arise.</li>
              <li>The city is way more cleaner and safer than any other cities in the world.</li>
              <li>Cross-cultural society.</li>
              <li>Root to many foreign universities.</li>
              <li>A leading global business hub</li>
              <li>Globally accredited degrees</li>
              <li>Enormous opportunity of getting scholarships.</li>
              <li>Popular tuition grants system</li>
            </ul>
            <h4 class="country-heading">Study Process in Singapore(Student Visa Process)</h4>
            <p>For those students who are coming from different countries intended to study in Singapore will apply for a student visa. After applying to the universities, when he/she will get the letter of approval he will be carried out a visa by the institution. A Student Pass is necessary to be applied to the Immigration and Checkpoints Authority (ICA) after one’s acceptance.</p>
            <ul>
              <li>All Students’ Pass applications are to be submitted through https://www.ica.gov.sg/reside/STP/apply.</li>
              <li>For more details, please visit the website of the Singapore Immigration & Checkpoints Authority at http://www.ica.gov.sg.</li>
            </ul>

            <h4 class="country-heading">Process of Applications:</h4>

            <ul>
              <li>If the willing student is 19 years old and below than that while he is applying and also want to apply for a full time course at an approved Private Education Organization (PEO),his application will be processed by the Singapore Immigration and checkpoints Authority (ICA) Directly.</li>
              <li>If the student wants to study there is above 19 years old and also his interest area is language, commercial, vocational or fine arts non-graduate/postgraduate degree course, an interview may be required by the embassy.</li>
            </ul>
            <h4 class="country-heading">Interview Process at Singapore Embassy in Beijing</h4>
            <p>A notification will be sent to the PEO in Singapore through an email of the interview schedule within 4 weeks of the application submission. Applicants have to contact to the PEO for the interview date. About 2 months after the interview, PEO will be informed of the application outcome.</p>
            <h4 class="country-heading">Processing time</h4>
            <p>The processing time takes generally between 2 to 4 months for the cases that need interviews. Enquiry on the outcome of the interview will not be entertained.</p>
            <h4 class="country-heading">Documents required in the time of interview:</h4>           
            <p>During attending an interview at PEO, students need to be appear with the following documents:</p>
            <p>Original copy, notarized copy and photocopy of the notarized copy of the applicant’s:</p>
            <ul>
              <li>Birth Certificate</li>
              <li>Highest educational level certificates.</li>
              <li>Highest educational level academic results;</li>
              <li>Financial/bank statement;</li>
            </ul>
            <h4 class="country-heading">Notarial certificates include:</h4>
            <ul>
              <li>Overseas study plan (duly signed and dated) of the applicant</li>
              <li>Original copy and photocopy of the applicant, his/her parents & spouse:
                <ul>
                  <li>identity card</li>
                  <li>household register</li>
                  <li>employment statements & letter from their respective employers (if applicable)</li>
                  <li>monthly salary records for 3 months period before the interview</li>
                  <li>business registration certificates if they are self-employed (if applicable)</li>
                </ul>
              </li>
              <li>Applicant’s passport and photocopy of the passport bio-data page</li>
              <li>If the applicant's parent(s)/step parents/spouse is a Singapore citizen or a Singapore permanent resident, the applicant must also furnish the original copy and notarized copy of the certificates of his parents'/step parent's/his own marriage certificate.</li>
            </ul>
            <p><strong>Notarial certificates must be issued by the local Notary Public Office, certified by the Consular Department of the Ministry of Foreign Affairs, People’s Republic of China and duly endorsed by the Embassy.</strong></p>
            <h4 class="country-heading">Security deposit</h4>
            <p>An amount of security deposit is bearable when one is applying for Singapore study visa. It is collected by the ICA from the student. The amount is $5,000 in the form of a banker’s guarantee from any well known bank in Singapore.</p>
            <h4 class="country-heading">Fees</h4>
            <p>The processing fee per application is S$30 which is required to submit to ICA. The fee is non-refundable irrespective of the outcome of the application otherwise the application will be withdrawn</p>
            <p>A registration fee of S$60 is payable when the applicants completes the formality towards the issuance of the student’s pass at ICA.</p>

            <h4 class="country-heading">Popular Universities in Singapore and fees:</h4>
            <p>Because of the top-notch educational system, high standard of living, cultural diversity, and many other factors, many students decide to study in Singapore. Students will discover an engaging atmosphere that brings students from all over the world together while pursuing their studies in Singapore. Also, there are a ton of locations in and around Singapore that you can visit while you are studying there. Because of the top-notch educational system, high standard of living, cultural diversity, and many other factors, many students decide to study in Singapore. Students will discover an engaging atmosphere that brings students from all over the world together while pursuing their studies in Singapore. Also, there are a ton of locations in and around Singapore that you can visit while you are studying there.</p>

            <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th style="text-align: center;">Sl No.</th>
                              <th>Name of the  University</th>
                              <th style="text-align: center;">Application Fee</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="text-align: center;">1</td>
                              <td>Curtin Singapore</td>
                              <td style="text-align: center;">SGD 500</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">2</td>
                              <td>EASB- East Asia Institute of Management</td>
                              <td style="text-align: center;">SGD 450</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">3</td>
                              <td>Global School of Technology & Management</td>
                              <td style="text-align: center;">SGD 267.50</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">4</td>
                              <td>HTMi Hotel and Tourism Management Institute</td>
                              <td style="text-align: center;">NA</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">5</td>
                              <td>James Cook University (JCU)</td>
                              <td style="text-align: center;">SGD 250</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">6</td>
                              <td>Kaplan Higher Education Academy (KHEA)</td>
                              <td style="text-align: center;">SGD 492</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">7</td>
                              <td>London School of Business and Finance</td>
                              <td style="text-align: center;">SGD 321</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">8</td>
                              <td>Management Development Institute of Singapore (MDIS)</td>
                              <td style="text-align: center;">SGD 481.50</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">9</td>
                              <td>Nanyang Institute of Management</td>
                              <td style="text-align: center;">SGD 428</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">10</td>
                              <td>PSB Academy</td>
                              <td style="text-align: center;">SGD 450</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">11</td>
                              <td>Raffles Design Institute</td>
                              <td style="text-align: center;">SGD 535</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">12</td>
                              <td>S P Jain School of Global Management</td>
                              <td style="text-align: center;">NA</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">13</td>
                              <td>SIM Global Education</td>
                              <td style="text-align: center;">SGD 481.50</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">14</td>
                              <td>William Angliss Institute</td>
                              <td style="text-align: center;">NA</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">15</td>
                              <td>Technical University of Munich (TUM) Asia</td>
                              <td style="text-align: center;">SGD 79</td>
                            </tr>
                          </tbody>
                        </table>
            </div>

            <h4 class="country-heading">Documents required for the UG course application:</h4>
            <ul>
              <li>Application Form</li>
              <li>10th Mark sheet and Certificate –Notary attested</li>
              <li>12th Mark sheet and Certificate- Notary attested</li>
              <li>Passport Copy – First and Last Page – Notary attested</li>
              <li>Letters of Recommendation – 2</li>
              <li>Statement of Purpose (Duly Signed by Student)</li>
              <li>Resume.</li>
              <li>IELTS or TOEFL score card if required–Notary attested</li>
              <li>Experience certificate – if any</li>
              <li>Birth Certificate</li>
              <li>Photograph</li>
            </ul>


            <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th>Popular Universities</th>
                              <th>Popular UG Courses</th>
                              <th>Fees Structure(1St year)</th>
                              <th>Exams</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>National University of Singapore</td>
                              <td>
                                <ul>
                                  <li>Bachelor of engineering</li>
                                  <li>BBA</li>
                                  <li>Bsc. In Physics</li>
                                </ul>
                              </td>
                              <td>11L-71L<br/> 11.66L<br/> 9.97L</td>
                              <td>IELTS, GRE, SAT</td>
                            </tr>

                            <tr>
                              <td>Nanyang Technological College</td>
                              <td>
                                <ul>
                                  <li>Bachelors of Business</li>
                                  <li>MBBS</li>
                                </ul>
                              </td>
                              <td>11L-66L<br/> 42.3L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>Singapore Management Universities</td>
                              <td>
                                <ul>
                                  <li>Bachelor in computer science</li>
                                  <li>Bachelor in business management</li>
                                  <li>Bachelor in Social Science.</li>
                                </ul>
                              </td>
                              <td>25.39L<br/> 25.29L<br/> 25.29L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>PSB Academy</td>
                              <td>
                                <ul>
                                  <li>Bachelor of science(biotech)</li>
                                  <li>Bachelor of Business</li>
                                  <li>BHM</li>
                                </ul>
                              </td>
                              <td>13.56L<br/> 10.7L<br/> 6.16L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>James Cook University</td>
                              <td>
                                <ul>
                                  <li>Bachelor of Information technology</li>
                                  <li>Bsc</li>
                                  <li>BBA</li>
                                  <li>BHM</li>
                                </ul>
                              </td>
                              <td>16.32L<br/> 17.3L<br/> 16.32L <br/>16.32L</td>
                              <td>IELTS</td>
                            </tr>
                          </tbody>
                        </table>
            </div>

            <h4 class="country-heading">Documents required for the PG course application:</h4>

            <ul>
              <li>Application Form</li>
              <li>10th Mark sheet and Certificate –Notary attested</li>
              <li>12th Mark sheet and Certificate- Notary attested</li>
              <li>Bachelor’s Degree – All individual Mark sheets and consolidated Mark sheet- Notary attested</li>
              <li>Degree Certificate or Provisional Degree Certificate- Notary attested</li>
              <li>Passport Copy – First and Last Page – Notary attested</li>
              <li>Letters of Recommendation – 2</li>
              <li>Statement of Purpose (Duly Signed by Student)</li>
              <li>Resume</li>
              <li>IELTS or TOEFL score card if required–Notary attested</li>
              <li>Experience certificate – if any</li>
              <li>Birth Certificate</li>
              <li>Photograph</li>
            </ul>

            <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">
                          <thead>
                            <tr style="background-color: #f48d8d;">
                              <th>Popular Universities</th>
                              <th>Popular PG Courses</th>
                              <th>Fees Structure(1St year)</th>
                              <th>Exams</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>National University of Singapore</td>
                              <td>
                                <ul>
                                  <li>MBA(Full Time)</li>
                                  <li>Masters in computer science</li>
                                </ul>
                              </td>
                              <td>56.4L<br/> 31.5L</td>
                              <td>IELTS, GRE, GMAT</td>
                            </tr>

                            <tr>
                              <td>Nanyang Technological College</td>
                              <td>
                                <ul>
                                  <li>Master of Science(IS)</li>
                                  <li>MBA</li>
                                  <li>Master of Science(Finance)</li>
                                </ul>
                              </td>
                              <td>21.63L <br/> 39.28L<br/> 34.34L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>Singapore Management Universities</td>
                              <td>
                                <ul>
                                  <li>MBA</li>
                                  <li>Masters of Science in computing</li>
                                </ul>
                              </td>
                              <td>38.07L<br/>12.09L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>PSB Academy</td>
                              <td>
                                <ul>
                                  <li>MBA</li>
                                  <li>MIM</li>
                                  <li>Master of cyber security</li>
                                </ul>
                              </td>
                              <td>12.67L<br/> 6.78L<br/> 13.6L</td>
                              <td>IELTS</td>
                            </tr>

                            <tr>
                              <td>James Cook University</td>
                              <td>
                                <ul>
                                  <li>MBA</li>
                                  <li>MIM</li>
                                  <li>MS</li>
                                </ul>
                              </td>
                              <td>22L<br/>22L<br/>22L</td>
                              <td>IELTS</td>
                            </tr>
                          </tbody>
                        </table>
            </div>

            <h4 class="country-heading">Visa Application Process in Singapore</h4>

            <p>REQUIRED DOCUMENTS FOR THE VISA APPLICATION:</p>
            <p>a current passport good for six months</p>
            <p>Passport-sized images</p>
            <p>a duplicate of your visa application form, filled and signed</p>
            <p>Specifics regarding your itinerary</p>
            <p>Evidence of hotel and flight reservations</p>
            <p>A duplicate of the return ticket</p>
            <p>A recent six-month bank statement from your bank demonstrating that you have sufficient funds to cover the cost of your trip.</p>
            <h4 class="country-heading">Visa Application Online</h4>
            <p>Moreover, a visa known as the iVisa can be obtained online in order to visit Singapore.</p>
            <p>The following documents are needed to complete the online application:</p>
            <p>Passport that is still active for at least six months</p>
            <p>A true email address</p>
            <p>Approved payment methods.</p>
            <p>Processing period:</p>
            <p>Regular processing: You will pay USD 20 and receive your visa in 24 hours.</p>
            <p>Rush processing: This will take four days to complete and costs US $40.00.</p>
            <p>Super Rush processing - This is the quickest option, and you can get the visa in just 30 minutes, but it costs USD 60.00.</p>
            <p>IVISA VALIDITY: The iVisa is valid for 14 days from the date of issuance or until the expiration of your passport. You may continue</p>
           
            <h4 class="country-heading">Job employability rate and career opportunity</h4>
            <p>The significance of Singapore's human capital in making up for its dearth of natural resources is one of the country's central national themes. Its resident population is little around six million, making its labour pool rather modest. Singapore depends on both developing a highly skilled local labour force and luring in the necessary foreign workers to meet the demands of its economy. In addition to helping to fill skill shortages, the foreign labour force also offers low-cost labour for industries that require a lot of labour, like construction, food and hospitality, and healthcare. Employing foreign labour would be more cost-effective and competitive than hiring local employees in several sectors in particular.</p>
            <p>The Ministry of Manpower's Advance Release of the Labour Force in Singapore 2022, which stated that the employment rate for residents aged 15 and over increased to 67.5% in 2022, increasing up for the second year in a row, supports this claim.</p>

            <h4 class="country-heading">Career Opportunity in Singapore</h4>
            <p>As Singapore has been the hub of business, international market, Foreign Trade and Technologies, so generating workforce to run those business will lead into ample of scope and opportunities for those who wants to make career in Singapore. Here varieties of occupations are available in the field of marketing, technology, healthcare and engineering etc. Foreign skilled workers will also get the same justification to the workplace with lots of scope. Here is the list of factors where career opportunities and talent management can created:</p>
            <p>Operations and logistics, Sales and marketing, manufacturing and production, IT and data, Front office and customer service etc.</p>
            </div>
          </div>
          </v-container>
      </v-card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                    <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                        <h3>Interested in studying abroad?</h3>
                    </div>
                    <v-container v-if="otp==false">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout row wrap >
                                <v-flex xs12 style="padding-top:10px;" >
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCountry"
                                     :items="countries"
                                     color="primary"
                                     label="Preferred Country *"
                                     item-text="countryName"
                                     item-value="countryName"
  
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCourse"
                                     :items="courses"
                                     color="primary"
                                     label="Preferred Course *"
                                     item-text="courses"
                                     item-value="courses"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                    <v-container v-if="otp==true">
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <label>Enter Your OTP here *</label>
                                    <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
            </v-card>
            <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
              <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                        <h3>Universities</h3>
                    </div>
               <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
                 <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>
  
               </marquee>
            </v-card>
  
                <div class="">
                  <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
                </div>
              <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
                <div style="margin:0px;cursor: pointer; ">
                  <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
                </div>
              </v-card>
  
          </div>
        </div>
      </div>
        <v-dialog v-model="dialog" width="500px" persistent>
           <v-card>
             <div style="height:150px;background-color:green;text-align:center;">
               <div style="padding-top:25px;">
                  <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
               </div>
             </div>
             <v-container>
               <div style="text-align:center">
                   <h4>Thank You</h4>
                   <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                   <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
               </div>
             </v-container>
           </v-card>
       </v-dialog>
    </v-app>
  </template>
  
  <script>
  import config from "./../../config.json";
  import moment from 'moment';
  export default {
    components: {
    },
    data() {
      return {
        tab: null,
        valid: true,
        btnSave: false,
        btnSave1: false,
        dialog: false,
        status: false,
        pin: 0,
        otp: false,
        name: [],
        featuredUniversities: [],
  
        ielts: true,
        toefl: false,
        gre: false,
        sat: false,
        gmat: false,
  
        details: null,
        image: null,
        banner: null,
        countryId: null,
        countryName: sessionStorage.getItem("countryName"),
  
        countries: [],
        selectedCountry: null,
  
        courses: [],
        selectedCourse: null,
  
        form: {
          name: null,
          email: null,
          mobileNumber: null
        },
        form1: {
          otp: null
        },
        emptyRule: [v => !!v || "Input is required"],
        rules: {
          required: value => !!value || "Required.",
          email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
          },
          mobileno: value => {
            const pattern = /^[1-9]{1}[0-9]{9}$/;
            return pattern.test(value) || "Mobile number not valid!!";
          },
        },
      };
      
    },
    
     mounted() {
      // this.axios
      //     .get(config.API + `country/author/${this.$route.params.id}`, {
      //       headers: {
      //         Authorization: "bearer " + sessionStorage.getItem("token")
      //       }
      //     })
      //     .then(res => {
      //       let _data = res.data.author;
      //       this.details = _data;
            
      //       if(_data.image!=null) {
      //         this.image = config.API + 'country/files1/' + _data.image;
      //       }
      //       if(_data.banner!=null) {
      //         this.banner = config.API + 'country/files2/' + _data.banner;
      //         console.log(this.banner);
      //       }
      //     })
      //     .catch(() => {
      //       this.$Progress.fail();
      //     });
  
        this.countryName = sessionStorage.getItem("countryName");
        this.image = sessionStorage.getItem("image");
        this.banner = sessionStorage.getItem("banner");
        this.countryId = sessionStorage.getItem("countryId");
          this.axios
        .get(config.API + `country/authors`, {
          headers: { Authorization: "Bearer " + sessionStorage.token }
        })
        .then(res => {
          let list = res.data.authors;
          console.log(list);
  
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            if(element.id!=this.countryId) {
              this.countries.push({
              id: element.id,
              countryName: element.countryName.toUpperCase(),
              src: config.API1 + "country/files/" + element.src,
              image: config.API1 + "country/files1/" + element.image
              })
            }
          }
  
          console.log(this.countries);
        });

        this.axios
      .get(`https://api.worldwin.org/api/Levels`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.courses.push(element.levelName)
        }
      });
  
  
      this.axios
          .post(
            config.API + `university/search`,
            {
              countryId: this.countryId
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            let list = res.data.result;
            console.log(list);

            for (let index = 0; index < list.length; index++) {
              const element = list[index];
              
              this.featuredUniversities.push({
                id: element.id,
                universityName: element.universityName,
                src: config.API1 + "university/files/" + element.src
              })
            }
              })
          .catch(err => {
          });
     },
  
   methods: {
     blg(item) {
       sessionStorage.setItem("blogTitle", item.title);
       sessionStorage.setItem("blogDescription", item.description);
       sessionStorage.setItem("blogSrc", item.src);
       this.$router.push("/blogDetail/" + item.id );
     },
     getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Country Details',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              comment: comment,
              pageName: 'Country Details',
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: "Website",
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        }
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      /* } else {
        this.$toaster.error(`Required field are empty!!`);
      } */
    },
    onCountry(item) {
    sessionStorage.setItem("countryName", item.countryName);
    sessionStorage.setItem("image", item.image);
    sessionStorage.setItem("banner", item.banner);
    sessionStorage.setItem("countryId", item.id); 
    ////this.$router.push("/countrydetail/" + item.id );
    if(item.countryName=='UK') {
      this.$router.push("/study-in-uk");
    }
    else if(item.countryName=='DUBAI') {
      this.$router.push("/study-in-dubai");
    }
    else if(item.countryName=='SINGAPORE') {
      this.$router.push("/study-in-singapore");
    }
    else if(item.countryName=='USA') {
      this.$router.push("/study-in-usa");
    }
    else if(item.countryName=='AUSTRALIA') {
      this.$router.push("/study-in-australia");
    }
    else if(item.countryName=='CANADA') {
      this.$router.push("/study-in-canada");
    }
   },
  
      onSubmit() {
        if (this.$refs.form1.validate()) {
          if(this.pin == this.form1.otp) {
            this.btnSave1 = true;
          this.axios
            .post(
              config.API + `enquiry/author`,
              {
                name: this.form.name,
                email: this.form.email,
                mobileNumber: JSON.parse(this.form.mobileNumber),
                country: this.selectedCountry,
                course: this.selectedCourse,
                page: 'Test Preparation',
                date: moment().format('MMMM Do YYYY')
              },
              {
                headers: {
                  Authorization: "bearer " + sessionStorage.getItem("token")
                }
              }
            )
            .then(res => {
              console.log(res);
              this.name = this.form.name.split(' ');
              let firstName = this.name[0];
              let lastName = null;
  
              if(this.name.length > 2) {
                lastName = this.name[1] + this.name[2]
              }
              else {
                lastName = this.name[1]
              }
              this.axios
            .post(
              `http://api.worldwin.org/api/Leads1`,
              {
                firstName: firstName,
                lastName: lastName,
                mobileNumber: JSON.parse(this.form.subject),
                cmsId: JSON.parse(res.data.result.id),
                email: this.form.email,
                guardianName: null,
                guardianNo: 0,
                guardianEmail: null,
                relation: null,
                address: null,
                nature: null,
                source: null,
                document: false,
                documentType: null,
                notes: null,
                levelId: 0,
                leadDetails: null,
                leadTrainings: null
              },
              {
                headers: {
                  Authorization: "bearer " + localStorage.getItem("token")
                }
              }
            )
            .then(res => {
              this.dialog = true;
              this.btnSave1 = false;
            })
            .catch(() => {
              this.$toaster.error(`Mobile no is already registered`);
              this.btnSave = false;
            });
            })
            .catch(() => {
              this.$toaster.error("Mobile no is already registered");
              this.btnSave1 = false;
            });
          }
          else {
            this.$toaster.error("Please put a valied OTP");
          }
        } else {
          this.$toaster.error(`Required field are empty!!`);
        }
      },
  
      cancel() {
        this.form.name = null;
        this.form.email = null;
        this.form.mobileNumber = null;
        this.otp = false;
        this.dialog = false;
      },
   }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
  </style>
  
  <style scoped>
  .banner {
    background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
    background-size: cover;
    height:200px;
  }
  .tst {
    border-radius:0px;
    height:300px;
    background-size: cover;
    color: white !important;
      
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  .tourtheme {
    height: 190px;
    margin: 15px;
    background-size: 100%;
    transition: background-size 1s ease-in-out !important;
  }
  .tourtheme:hover {
    background-size: 120%;
  }
  .partner {
      margin-top: 15px;
      text-align: center;
      font-size: 23px;
      background-image: linear-gradient(to right, #f19a28 , #f12525);
      border-radius: 0px !important;
      color: whitesmoke !important;
  }
  .country-heading {
    color:#EC1616;
  }
  .country p {
    font-weight: 300;
    color:#666666;
    text-align: justify;
  }
  .v-card {
    padding: 10px;
    border-radius: 8px;
  }
  .v-sheet--offsets {
    top: -50px;
    position: relative;
  }
  .v-sheet--offset {
    top: -30px;
    position: relative;
  }
  .v-sheet--offsetf {
    top: -100px;
    position: relative;
  }
  .swo {
    box-shadow: none !important;
  }
  .opa {
    opacity: 1;
  }
  div.scroll { 
                  margin:4px, 4px; 
                  padding:4px; 
                  width: auto; 
                  height: 254px; 
                  overflow-x: hidden; 
                  overflow-x: auto; 
                  text-align:justify; 
              }
  
  .themecap {
    font-family: 'Open Sans', sans-serif;
    padding-top: 130px;
    color: white;
  }
  .top-left {
    font-family: 'Roboto Mono', monospace;
    font-size:40px ;
    padding-top: 200px;
    color: white;
    text-align: center;
  }
  .salont {
    font-family: 'Patua One', cursive;
  }
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .hvr:hover {
    cursor: pointer;
    border-radius: 5px !important;
    border : 1px solid;
    border-color: black !important;
    transition-duration: 0.7s;
    text-decoration: none !important;
  }
  .v-table tbody tr:not(:last-child) {
      border-bottom: none !important;
  }
  .con {
    margin-top: -100px;
    max-width: 1300px;
  }
  @media screen and (min-width: 768px){
    .con {
      margin-top: 0px!important;}
  
    }
  @media screen and (max-width: 768px) {
    .res {
      display: none;
    }
  }
  @media screen and (min-width: 768px){
    .man {
      display: none;
    }
  }
  img.center {
      display: block;
      margin: 0 auto;
  }
  .recent {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .srch {
    position: absolute;
    z-index: 10;
    left: 16%;
    top: 0%;
  }
  .item {
      border:1px solid !important;
  }
  </style>
  